var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    [
      _c("h1", [_vm._v("Museum Grade Picture & Photo Mounts")]),
      _c("p", [
        _vm._v(
          "Select from 2 different colours of museum grade Larson-Juhl mountboard. Each board is 2.2mm (2200micron) thick and 100% cotton core. \nThese boards offer the best possible protection for your artwork and photographs, ensuring that over time they will not be damaged. \nMuseums use these boards to display the finest artwork in the world, so you can be sure that is the best you can possibly find."
        ),
      ]),
      _c("bespoke-mount", {
        attrs: {
          mountboards: _vm.mountboards,
          type: "museum",
          loading: _vm.loading,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }